export const queryKeys = {
    deployments: "deployments",
    devices: "devices",
    pipelineMetrics: "pipeline-metrics",
    rawcounts: "raw-counts",
    videos: "video",
    image: "image",
    sites: "sites",
};
